export const METABASE_DASHBOARD_URLS = {
  itau: [
    {
      projectId: 1,
      url: 'https://btime-team.metabaseapp.com/public/dashboard/5e7824b1-2bbf-4a9b-8d6f-5530708d48b8'
    },
    {
      projectId: 2,
      url: 'https://btime-team.metabaseapp.com/public/dashboard/5e7824b1-2bbf-4a9b-8d6f-5530708d48b8'
    },
    {
      projectId: 3,
      url: 'https://btime-team.metabaseapp.com/public/dashboard/5e7824b1-2bbf-4a9b-8d6f-5530708d48b8'
    }
  ],
  condominios: [
    {
      projectId: 1,
      url: 'https://btime-team.metabaseapp.com/public/dashboard/dbcdb1f0-d521-41a9-83e1-492e9ca48449'
    }
  ],
  cubo: [
    {
      projectId: 1,
      url: 'https://btime-team.metabaseapp.com/public/dashboard/eeb672f6-3368-4f19-bbe6-a1e36023c643'
    },
    {
      projectId: 3,
      url: 'https://btime-team.metabaseapp.com/public/dashboard/eeb672f6-3368-4f19-bbe6-a1e36023c643'
    }
  ],
  tembici: [
    {
      projectId: 1,
      url: 'https://btime-team.metabaseapp.com/public/dashboard/54db86ca-e8f3-4024-a097-3b192dc24606'
    },
    {
      projectId: 4,
      url: 'https://btime-team.metabaseapp.com/public/dashboard/c58a350d-bd6e-415e-81e1-e5b93ccbc799'
    }
  ]
}
